import React from "react";
import Page from "../components/Page";
import Button from "../components/elements/Buttons/Button";
import Layout from "../components/Layout";
import ServiceFinancial from "../components/components/ServiceFinancial/ServiceFinancial";
import Space from "../components/elements/Space/Space";
import ContactForm from "../components/components/ContactForm/ContactForm";
import FullImageBanner from "../components/components/FullImageBanner/FullImageBanner";
import Text from "../components/atoms/Text/Text";
import Herobanner from "../components/elements/Herobanner/Herobanner";
import {scrollToContact} from "../utility/function";
import Clients from "../components/components/Clients/Clients";

const Finanziario = () => (
  <Page title='Finanziario' description='Gestiamo campagne esclusivamente a performance sui principali verticali finanziari, anche con prequalifica telefonica.' image='/favicon.png'>
    <Layout navigationCallback={() => scrollToContact()}>
      <Herobanner backgroundUrl={"/herobanner/finanziario.svg"}>
        <h1 className='mb-3'>Lead per scalare il tuo business</h1>
        <Text>Gestiamo campagne esclusivamente a performance sui principali verticali finanziari, anche con prequalifica telefonica.</Text>
        <Button customClass='mt-6' onClick={() => scrollToContact()}>
          Contattaci
        </Button>
      </Herobanner>

      <Space mobile={10} table={15} desktop={20} />
      {/* 
      <Numbers icon='graph'>
        <Number number={"16K"} text={"Clienti totali"} />
        <Number number={"150000+"} text={"Leads generati"} />
        <Number number={"460+"} text={"Caffé presi"} />
      </Numbers>

      <Space mobile={10} table={4} desktop={10} />

      <ContactLineCTA callback={() => scrollToContact()} />

      <Space mobile={10} table={4} desktop={20} /> */}

      <ServiceFinancial iconSize='small'></ServiceFinancial>

      <Space mobile={20} table={20} desktop={20} />

      <FullImageBanner image='/background/full-image-affiliate.jpg' ctaLine1='La soddisfazione del cliente' ctaLine2='è ciò che ci muove ogni giorno.' />

      <Space mobile={20} table={20} desktop={20} />
      <Clients />

      <Space mobile={20} table={20} desktop={20} />

      <ContactForm text_line1='Richiedi ora informazioni' />
    </Layout>
  </Page>
);

export default Finanziario;
